import React, { Fragment, Component } from 'react'
import { translate } from 'react-i18next'
import { SERVICES_TABS, SERVICES } from '../../utils/constants'
import ServicesCard from '../ServicesCard'
import './index.sass'

class ServicesTabs extends Component {
  render = () => {
    const { t, serviceType } = this.props
    return (
      <div className="services-tabs">
        <div>
          {Object.keys(SERVICES[serviceType]).map((subTab, ind) => (
            <Fragment key={ind}>
              {SERVICES[serviceType][subTab].label && (
                <p className="subtitle-1 services-sub-title">
                  {t(`services.${SERVICES[serviceType][subTab].label}`)}
                </p>
              )}
              <div className="services-card-list">
                {SERVICES[serviceType][subTab].items.map(card => (
                  <ServicesCard
                    value={card.value}
                    label={card.label}
                    key={card.value}
                    serviceTab={SERVICES_TABS[serviceType].value}
                  />
                ))}
              </div>
            </Fragment>
          ))}
        </div>
      </div>
    )
  }
}

export default translate('translations')(ServicesTabs)
